<template>
    <v-dialog v-model="displayModal" width="500">
        <v-card>
            <component
                v-if="buyOption.component"
                v-for="buyOption in buyOptions"
                :is="buyOption.component"
                :buy-option="buyOption"
                :key="buyOption.id"
                v-model="buyOptionsValues[buyOption.indexname].Values"
            ></component>

            <v-card-actions>
                <v-layout row wrap pb-1>
                    <v-flex sm6 xs12 px-2>
                        <v-btn
                            @click="setDisplayBuyOptionsModal(false)"
                            block
                        >
                            {{'Cancel' | translation}}
                        </v-btn>
                    </v-flex>

                    <v-flex sm6 xs12 px-2 :class="{'pt-2': $vuetify.breakpoint.xsOnly}">
                        <basket-button
                            :buy-options="Object.values(buyOptionsValues)"
                            @afterAddToBasket="setDisplayBuyOptionsModal(false)"
                            :disabled="isBasketButtonDisabled"
                            :large="false"
                        ></basket-button>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import PackageConfigBuyOption from './BuyOptions/PackageConfigBuyOption';
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Vue from 'vue';
    import BasketButton from './BasketButton';

    const moduleName = 'BuyOptions';
    const productModuleName = 'Product';

    export default {
        name: moduleName,
        props: [
            'buyOptions',
        ],
        components: {
            [PackageConfigBuyOption.name]: PackageConfigBuyOption,
            BasketButton,
        },
        computed: {
            ...mapState(productModuleName, [
                'displayBuyOptionsModal',
            ]),
            displayModal: {
                get() {
                    return this.displayBuyOptionsModal;
                },
                set(value) {
                    this.setDisplayBuyOptionsModal(value);
                },
            },
            buyOptionsValues() {
                let values = {};

                if (this.buyOptions) {
                    for (let buyOption of this.buyOptions) {
                        let buyOptionCopy = Object.assign({}, buyOption);
                        buyOptionCopy.Values = {};
                        values[buyOption.indexname] = buyOptionCopy;
                    }
                }

                return Vue.observable(values);
            },
            isBasketButtonDisabled() {
                let disabled = true;

                for (let buyOptionValues of Object.values(this.buyOptionsValues)) {
                    if (buyOptionValues) {
                        disabled = disabled && !Object.values(buyOptionValues.Values).length;
                    }
                }

                return disabled;
            },
        },
        methods: {
            ...mapMutations(productModuleName, [
                'setDisplayBuyOptionsModal',
             ]),
            ...mapActions(productModuleName, {
                dispatchBuyProduct: 'buyProduct',
            }),
        },
    };
</script>